import { createContext } from "react";

export const SupervisionContext = createContext({
    updateData: () => {},
    configsDetails: null,
    configState: null
});